import { Box, Button, CircularProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface RestartButtonProps {
  isRestarting: boolean
  onClick: () => void
}

export function RestartButton({ isRestarting, onClick }: Readonly<RestartButtonProps>) {
  const { t } = useTranslation()

  return (
    <Button color="secondary" disabled={isRestarting} sx={{ width: 200 }} variant="contained" onClick={onClick}>
      {isRestarting ? (
        <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', position: 'relative' }}>
          <CircularProgress color="inherit" size={20} sx={{ position: 'absolute', left: 0 }} />
          <Box sx={{ width: '100%', textAlign: 'center' }}>{t('controllers.actions.restarting')}</Box>
        </Box>
      ) : (
        t('controllers.actions.restart_button')
      )}
    </Button>
  )
}
